// Tiny WebAudio synth SFX — no audio files, no loader, works offline.
// Respects settings.soundEnabled; safe to call before user gesture (no-ops
// until the AudioContext can resume inside a tap handler).

let ctx: AudioContext | null = null;

function ac(): AudioContext | null {
  try {
    if (!ctx) {
      const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Ctor) return null;
      ctx = new Ctor();
    }
    if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);
    return ctx.state === 'suspended' ? null : ctx;
  } catch {
    return null;
  }
}

function blip(freqFrom: number, freqTo: number, ms: number, gain = 0.08): void {
  const c = ac();
  if (!c) return;
  try {
    const t = c.currentTime;
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freqFrom, t);
    osc.frequency.exponentialRampToValueAtTime(Math.max(40, freqTo), t + ms / 1000);
    g.gain.setValueAtTime(gain, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + ms / 1000);
    osc.connect(g).connect(c.destination);
    osc.start(t);
    osc.stop(t + ms / 1000 + 0.02);
  } catch {
    /* ears are optional */
  }
}

/** Chick peep: quick upward chirp. */
export function peep(enabled: boolean): void {
  if (!enabled) return;
  blip(1200, 2400, 120);
  window.setTimeout(() => blip(1400, 2600, 90), 110);
}

/** Happy cluck: two low notes. */
export function cluck(enabled: boolean): void {
  if (!enabled) return;
  blip(400, 250, 110, 0.07);
  window.setTimeout(() => blip(450, 300, 100, 0.07), 120);
}

/** UI pop: single short tick for buttons/chores. */
export function pop(enabled: boolean): void {
  if (!enabled) return;
  blip(700, 900, 60, 0.05);
}
